import { HcmusMobile } from "./HcmusMobile";
import { UCalgaryMobile } from "./UCalgaryMobile";

function EducationMobile() {
  return (
    <section
      id="education"
      className="pt-[95px]"
    >
      <div className="container items-start">
        <div className="flex items-center">
          <p className="text-xl font-bold mb-10">EDUCATION</p>
        </div>
        <UCalgaryMobile />
        <HcmusMobile />
      </div>
    </section>
  );
}

export default EducationMobile;
